import { combineEpics } from 'redux-observable';

import { findTableEntriesEpic }              from './FindTableEntries/FindTableEntriesEpic';
import { findTableConfigsEpic }              from './FindTableConfigs/FindTableConfigsEpic';
import { updateTableConfigEpic }             from './UpdateTableConfig/UpdateTableConfigEpic';
import { updateColumnConfigEpic }            from './UpdateColumnConfig/UpdateColumnConfigEpic';
import { findTableColumnsConfigForUserEpic } from './FindTableColumnsConfigForUser/FindTableColumnsConfigForUserEpic';


export default combineEpics(
  findTableEntriesEpic,
  findTableConfigsEpic,
  updateTableConfigEpic,
  updateColumnConfigEpic,
  findTableColumnsConfigForUserEpic,
);
